<template>
    <app-layout>
        <Head>
            <title>Dashboard</title>
        </Head>

        <template v-slot:overline>
            <translate>Willkommen</translate>
        </template>

        <template v-slot:headline>{{ this.$page.props.user.name }}</template>

        <div class="dashboard">
            <div class="dashboard--tabs">
                <nav>
                    <ul>
                        <li>
                            <dashboard-tab icon="user-profile-square" :active="currentCard[0]" @click="toggleCard(0)" :count="countActiveOffers">
                                <translate>aktive<br/>Angebote</translate>
                            </dashboard-tab>
                        </li>
                        <li>
                            <dashboard-tab icon="user-profile-square" :active="currentCard[1]" @click="toggleCard(1)" :count="countNewOrders">
                                <translate>neue<br/>Bestellungen</translate>
                            </dashboard-tab>

                        </li>
                        <li>
                            <dashboard-tab icon="user-profile-square" :active="currentCard[2]" @click="toggleCard(2)" :count="countRunningAskForQuotes">
                                <translate>laufende<br/>Anfragen</translate>
                            </dashboard-tab>
                        </li>
                        <li>
                            <dashboard-tab icon="user-profile-square" :active="currentCard[3]" @click="toggleCard(3)" :count="countRunningOrders">
                                <translate>laufende<br/>Bestellungen</translate>
                            </dashboard-tab>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="dashboard--content">

                <dashboard-active-offers :active-offers="activeOffers" v-if="currentCard[0]"/>

                <dashboard-new-orders :new-orders="newOrders" v-if="currentCard[1]"/>

                <dashboard-running-ask-for-quotes :running-ask-for-quotes="runningAskForQuotes" v-if="currentCard[2]"/>

                <dashboard-running-orders :running-orders="runningOrders" v-if="currentCard[3]"/>

            </div>
        </div>
    </app-layout>

</template>
<script>
import AppLayout from '@partfactory/Layouts/AppLayout';
import DashboardActiveOffers from '@partfactory/Pages/Client/Dashboard/DashboardActiveOffers';
import DashboardNewOrders from '@partfactory/Pages/Client/Dashboard/DashboardNewOrders';
import DashboardRunningAskForQuotes from '@partfactory/Pages/Client/Dashboard/DashboardRunningAskForQuotes';
import DashboardRunningOrders from '@partfactory/Pages/Client/Dashboard/DashboardRunningOrders';
import DashboardTab from '@partfactory/Pages/Client/Dashboard/DashboardTab';


export default {
    name: 'ClientDashboard',
    components: {
        DashboardTab,
        DashboardRunningOrders,
        DashboardRunningAskForQuotes,
        DashboardNewOrders,
        DashboardActiveOffers,
        AppLayout,
    },
    props: {
        user: Object,
        runningAskForQuotes: Object,
        activeOffers: Object,
        runningOrders: Object,
        newOrders: Object,
    },
    data() {
        return {
            currentCard: {
                0: true,
                1: false,
                2: false,
                3: false
            },
        };
    },
    created() {
        const cardIndex = this.$page.props?.vueSettings?.card_index;
        if (cardIndex) this.toggleCard(cardIndex);
    },
    computed: {
        countActiveOffers() {
            return this.activeOffers.length;
        },
        countNewOrders() {
            return this.newOrders.length;
        },
        countRunningAskForQuotes() {
            return this.runningAskForQuotes.length;
        },
        countRunningOrders() {
            return this.runningOrders.length;
        },
    },
    methods: {
        toggleCard(cardIndex) {
            this.$inertia.post(this.$$route('vue-settings'), {
                _token: this.$page.props.csrf_token,
                card_index: cardIndex,
            });

            return Object.keys(this.currentCard).map((card,index) => {
                this.currentCard[index] = index === cardIndex;
            });
        },
    },
};
</script>
